import React from 'react';
import { connect } from "react-redux";
import { Translate, withLocalize } from 'react-localize-redux';
import { withRouter } from "react-router";
import { bindActionCreators } from 'redux';
import ReactHtmlParser from 'react-html-parser';
import { hasPermission } from "../../store/apiWrapper";
import { searchActions } from '../../store/searchStore';
import { strip } from "../common/utils";
import BasicInfoLink from '../common/basicInfoLink';
import { Link } from 'react-router-dom';
import classnames from 'classnames';
import BbCheckbox from "../styling/bbCheckbox";

import FoIcon from '../../img/icons/FyzickaOsoba';
import FpoIcon from '../../img/icons/FyzickaOsobaPodnikatel';
import PoIcon from '../../img/icons/PravnickaOsoba';
import AddrIcon from '../../img/icons/Domu';
import CheckIcon from "../../img/icons/Check";
import CrossIcon from '../../img/icons/Cross';
import SvgBBiconsOdstranit from '../../img/icons/BBiconsOdstranit'

import './subjectClipboard.scss';

class SubjectClipboard extends React.Component {
    inputs = {};
    state = {
        selected: 0
    };

    render() {
        return (
            <article className="panel">
                <div className="panel-heading">
                    <div className='panel-heading-title'>
                        <div style={{ marginRight: 'auto', marginTop: 'auto', marginBottom: 'auto' }}><Translate id="Search.Clipboard" /></div>
                        <CrossIcon className='icon-centered' onClick={this.props.closePanel} style={{ marginLeft: '.5em' }} />
                    </div>
                </div>
                <div className='search-progress'></div>
                <div className="panel-block subject-clipboard">
                    {this.props.clipboard.length === 0 && <div style={{ fontSize: '.9em', paddingTop: "1em", paddingLeft: "1em", paddingRight: "0.5em" }}><Translate id="Search.Clipboard.NoSubjects" /></div>}
                    {this.props.clipboard.length !== 0 && this.renderHasSubjects()}
                </div>
            </article>
        );
    }

    renderHasSubjects = () => {
        return (<>
            {this.renderCheckAllButton(this.state.selected)}
            {this.props.clipboard.map(c => this.renderEntityLine(c))}
            {this.renderButtons(this.state.selected)}
        </>);
    }

    renderCheckAllButton = (selected) => {
        const allChecked = (selected === 0) ? false : ((selected === Object.keys(this.inputs).length) ? true : null);

        return (
            <div className="bb-chk-grp-all">
                <BbCheckbox name="all" label={this.props.translate("Charts.CheckAll")} value={allChecked} id="clip_all" onChange={(v) => this.checkAll(v)} />
            </div>
        );
    }

    checkAll = (value) => {
        const keys = Object.keys(this.inputs)
        for (let i = 0; i < keys.length; i++) {
            if (this.inputs[keys[i]] !== undefined && this.inputs[keys[i]] !== null) {
                this.inputs[keys[i]].checked = value;
            }
        }

        const selected = (value) ? keys.length : 0;
        this.setState({ selected: selected });
    }

    renderButtons = (selected) => {
        const enableMerge = selected >= 2;
        const ids = this.joinIds();
        const sortByName = ((a, b) => {
            if (a.name < b.name) { return -1; }
            if (a.name > b.name) { return 1; }
            return 0;
        })
        const sortByClipboardId = ((a, b) => {
            if (a.clipboardId < b.clipboardId) { return -1; }
            if (a.clipboardId > b.clipboardId) { return 1; }
            return 0;
        })

        return (<>
            {this.props.clipboard.length >= 2 && <>
                <div className='link-functional' style={{ fontSize: '.9em' }} onClick={() => this.props.sortClipboard(sortByName, this.props.translate('Search.Clipboard.Sorted'))}>
                    <Translate id='Search.Clipboard.SortAlphabetically' />
                </div>
                <div className='link-functional' style={{ fontSize: '.9em' }} onClick={() => this.props.sortClipboard(sortByClipboardId, this.props.translate('Search.Clipboard.Sorted'))}>
                    <Translate id='Search.Clipboard.SortByAddition' />
                </div>
            </>}

            {this.props.clipboard.length >= 1 && <>
                <div className='link-functional' style={{ fontSize: '.9em' }} onClick={() => this.props.clearClipboard(this.props.translate('Search.Clipboard.Cleared'))}>
                    <Translate id='Search.Clipboard.Clear' />
                </div>
            </>}

            <div className={`buttons`} style={{ paddingBottom: '.5em', justifyContent: 'center', paddingTop: "1.5em" }}>
                <button className={classnames('bb-button small gradient-1', { 'is-square': localStorage.locales_button_style === 'square' })} onClick={() => { this.props.history.push(`/relation-chart/${ids}?mode=merge`) }} disabled={!enableMerge}>
                    <Translate id='Search.Clipboard.Merge' />
                </button>
            </div>
        </>);
    }

    joinIds = () => {
        const keys = Object.keys(this.inputs)
        let selected = [];
        for (let i = 0; i < keys.length; i++) {
            if (this.inputs[keys[i]] !== undefined && this.inputs[keys[i]] !== null && this.inputs[keys[i]].checked) {
                selected.push(keys[i]);
            }
        }
        return selected.join(',');
    }

    renderEntityLine = (entityInfo) => {
        let batch = [];
        if (entityInfo.type === 2 && entityInfo.dateOfBirth && entityInfo.dateOfBirth.trim()) {
            batch.push(
                <React.Fragment key="1">
                    <Translate id="Report.NaturalIdentData.DateOfBirth" />:&nbsp;
                    {entityInfo.dateOfBirthFormated}
                </React.Fragment>
            );
        }

        if (entityInfo.type !== 2 && entityInfo.ico && entityInfo.ico.trim()) {
            batch.push(
                <React.Fragment key="2">
                    <Translate id="Report.CompanyIdentification.Ico" />:&nbsp;
                    {ReactHtmlParser(entityInfo.ico)}
                </React.Fragment>
            );
        }

        const Icon = entityInfo.type === 1 ? (entityInfo.entrepreneur === true ? FpoIcon : PoIcon) : entityInfo.reports.AR ? AddrIcon : FoIcon;

        return (<div className="widget-subject-row" key={entityInfo.entityId}>
            <div className="bb-chk-grp" style={{marginTop:"1px"}}>
                <input ref={el => this.inputs[entityInfo.entityId] = el} id={`clip_${entityInfo.entityId}`} type="checkbox" onClick={(evnt) => this.onChange(evnt, entityInfo.entityId, true)} />
                <label className="checkbox-label" htmlFor={this.props.id} onClick={(evnt) => this.onChange(evnt, entityInfo.entityId, false)}>
                    <CheckIcon className='checked-checkbox-label' />
                </label>
            </div>
            <div className='search-result-icon'>
                <Icon className='svg-standard-fill' />
            </div>
            <div className='subject-data'>
                <div>
                    {hasPermission(null, "SimpleReport") ?
                        <BasicInfoLink entityId={entityInfo.entityId} isAddress={entityInfo.reports.AR} title={strip(entityInfo.name)}>
                            {ReactHtmlParser(`<b>${entityInfo.name}</b>`)}
                        </BasicInfoLink> :
                        <React.Fragment>{ReactHtmlParser(`<b>${entityInfo.name}</b>`)}</React.Fragment>
                    }</div>
                <div >
                    <div>{batch}</div>
                </div>
            </div>
            <div className='subject-icons'>
                <div className='subject-icon' onClick={() => this.props.removeFromClipboard(entityInfo, this.props.translate('Search.Clipboard.SubjectRemoved'))}><SvgBBiconsOdstranit style={{ fill: '#8d949e' }} /></div>
            </div>
        </div>)
    }

    onChange = (evnt, entity, onInput) => {
        if (!onInput) {
            this.inputs[entity].checked = !this.inputs[entity].checked;
        }

        const keys = Object.keys(this.inputs)
        let selected = 0;
        for (let i = 0; i < keys.length; i++) {
            if (this.inputs[keys[i]] !== undefined && this.inputs[keys[i]] !== null && this.inputs[keys[i]].checked) {
                selected = selected + 1;
            }
        }
        this.setState({ selected });
    }
}

export default withRouter(withLocalize(connect(
    state => ({ ...state.search }),
    dispatch => bindActionCreators({ ...searchActions }, dispatch)
)(SubjectClipboard)));
